import React from 'react'
import { IonItem, IonLabel } from '@ionic/react'
import {
  buildInputValidationIdForMobile,
  buildInputValidationIdForTablet,
} from '../../features/validation/util/validation.util'
import { IValidation } from '../../features/validation/store/validation.types'
import './Validation.component.css'
import { useSelector } from 'react-redux'
import { getRulesSelector } from '../../features/rules/selectors'
import { getErrorMessage } from '../../utilities/runRulesValidation.util'
import useDeviceMetrics from '../../utilities/useDeviceMetrics'

const Validation: React.FC<IValidation> = (props: IValidation) => {
  const { id, cardinalityKey, isTablet, isMobile, showReduxStateErrorsOnlyFlag } = props
  const rulesState = useSelector(getRulesSelector)
  const { errors } = rulesState
  const { isTablet: deviceIsTablet } = useDeviceMetrics()

  if (isTablet && isMobile) {
    throw Error(`DEV Error: Both isTablet and isMobile are true for: ${id}`)
  }

  const getDataTestId = () => {
    return getValidationId()
  }

  const getValidationId = () => {
    if (isTablet) {
      return buildInputValidationIdForTablet(id, cardinalityKey)
    }

    if (isMobile) {
      return buildInputValidationIdForMobile(id, cardinalityKey)
    }

    return deviceIsTablet
      ? buildInputValidationIdForTablet(id, cardinalityKey)
      : buildInputValidationIdForMobile(id, cardinalityKey)
  }

  return (
    <div className='validation-wrapper'>
      <IonItem tabIndex={-1} data-testid={getDataTestId()} lines='none' className='ion-no-margin validation'>
        <IonLabel
          color='danger'
          className='ion-text-wrap ion-no-margin ion-no-padding validation-text'
          id={getValidationId()}>
          {getErrorMessage(errors, id, cardinalityKey, showReduxStateErrorsOnlyFlag)}
        </IonLabel>
      </IonItem>
    </div>
  )
}

export default Validation
